import React, { useEffect, useState } from 'react';
import Button from '../../../../../../component/ui/Button';
import InputField from '../../../../../../component/form/FormInput';
import Modal from '../../../../../../component/modal/Modal';
import upArrowIcon from '../../../../../../assets/image/up-arrow.png';
import downArrowIcon from '../../../../../../assets/image/down-arrow.png';
import editIcon from '../../../../../../assets/image/edit-icon.png';
import deleteIcon from '../../../../../../assets/image/delete-icon.png';
import marksIcon from '../../../../../../assets/image/marks-icon.png';
import { toast } from 'react-toastify';
import {
	createTaxRates,
	deleteTaxRate,
	getTaxRates,
	updateStatusTaxRates,
} from '../../../../../../services/settings/organization';
import PageLoader from '../../../../../../component/PageLoader';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';

export default function TaxRates({ isOpenModal, setIsOpenModal }) {
	const [headerDropDown, setHeaderDropDown] = useState('All');
	const [isOpenTaxTableDropdown, setIsOpenTaxTableDropdown] = useState(null);
	const [error, setError] = useState({});
	const [loader, setLoader] = useState(false);
	const [isLoading, setLoading] = useState(false);
	const [sortDirection, setSortDirection] = useState({});
	const [params, setParams] = useState({
		pageSize: 10000,
		page: 1,
		orderBy: '',
		sortBy: '',
		filterBy: '',
		filterValue: '',
	});

	const [taxRateForm, setTaxRatesForm] = useState({
		tax_rate_id: null,
		tax_name: '',
		rate_in_percentage: '',
		is_active: true,
	});
	const sortIconMap = {
		asc: <IoIosArrowRoundUp />,
		desc: <IoIosArrowRoundDown />,
	};
	const [taxRates, setTaxRates] = useState([]);

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.order_by,
			sortBy: newDirection,
		}));
	};

	const handleFilterData = (type) => {
		setHeaderDropDown(type);
		setParams((prev) => ({
			...prev,
			filterBy: type === 'All' ? '' : 'is_active',
			filterValue: type === 'All' ? '' : type === 'Active Taxes' ? true : false,
		}));
	};

	const handleDropdown = (id) => {
		if (isOpenTaxTableDropdown !== id) {
			setIsOpenTaxTableDropdown(id);
		} else {
			setIsOpenTaxTableDropdown(null);
		}
	};

	const resetTaxRate = () => {
		setTaxRatesForm({
			tax_rate_id: null,
			tax_name: '',
			rate_in_percentage: '',
			is_active: true,
		});
	};

	const handleOpenModal = (index = '') => {
		if (index !== '') {
			var data = taxRates[index];
			setTaxRatesForm((prev) => ({
				tax_rate_id: data.tax_rate_id,
				tax_name: data.tax_name,
				rate_in_percentage: data.rate_in_percentage,
				is_active: data.is_active,
			}));
		} else {
			const data = { tax_rate_id: null, tax_name: '', rate_in_percentage: '', is_active: true };
			setTaxRatesForm(data);
		}
		setIsOpenTaxTableDropdown(null);
		setIsOpenModal(true);
	};

	const handleFormData = (key, value, required = false) => {
		setTaxRatesForm((prev) => ({
			...prev,
			[key]: value,
		}));

		if (required) {
			var newError = { ...error };
			if (value === '' || value === null || value === undefined) {
				newError[key] = `Please enter ${key.split('_').join('')} in the field`;
			} else {
				delete newError[key];
			}
		}
	};

	const checkValidation = () => {
		var newError = { ...error };
		if (
			taxRateForm.tax_name === '' ||
			taxRateForm.tax_name === null ||
			taxRateForm.tax_name === undefined
		) {
			newError.tax_name = 'Please enter tax name in the field';
		} else {
			delete newError.tax_name;
		}
		if (
			taxRateForm.rate_in_percentage === '' ||
			taxRateForm.rate_in_percentage === null ||
			taxRateForm.rate_in_percentage === undefined
		) {
			newError.rate_in_percentage = 'Please enter tax rate in the field';
		} else {
			delete newError.rate_in_percentage;
		}

		if (Object.keys(newError).length > 0) {
			setError(newError);
			return true;
		} else {
			return false;
		}
	};

	const handleTaxRatesSave = async (isEdit) => {
		let isError = checkValidation();
		if (isError) {
			return toast.error(
				`${isEdit ? 'Update' : 'Create'} tax rates failed! Please fill required fields.`,
			);
		} else {
			try {
				setLoader(true);
				var res = await createTaxRates(taxRateForm);
				if (res.success === true) {
					setIsOpenModal(false);
					toast.success(res.message);
					resetTaxRate();
					getTaxRateList();
				} else {
					toast.error(res.message || 'something went wrong!');
				}
			} catch (e) {
				toast.error(e.message || 'Something went wrong!');
			} finally {
				setLoader(false);
			}
		}
	};

	const getTaxRateList = async () => {
		try {
			setLoading(true);
			const { tax_rates, active_count, max_active } = await getTaxRates(params);
			setTaxRates(tax_rates);
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		} finally {
			setLoading(false);
		}
	};

	const handleDeleteTaxRate = async (id) => {
		try {
			setIsOpenTaxTableDropdown(null);
			const res = await deleteTaxRate(id);
			if (res.success === true) {
				toast.success(res.message);
				getTaxRateList();
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};
	const updateStatus = async (id, isActive) => {
		try {
			setIsOpenTaxTableDropdown(null);
			var body = {
				is_active: isActive,
				tax_rate_id: id,
			};
			const res = await updateStatusTaxRates(body);
			if (res.success === true) {
				toast.success(res.message);
				getTaxRateList();
			} else {
				toast.error(res.message || 'Something went wrong!');
			}
		} catch (error) {
			toast.error(error.message || 'Something went wrong!');
		}
	};

	useEffect(() => {
		getTaxRateList();
	}, [params]);

	return (
		<div style={{ height: 'calc(100vh - 150px)', overflowX: 'hidden', overflowY: 'auto' }}>
			{' '}
			{isLoading ? (
				<PageLoader />
			) : (
				<div style={{ overflow: 'hidden' }}>
					<div
						className="product-pg-header tax-dropdown-header"
						style={{
							position: 'sticky',
							top: 0,
							zIndex: 100,
							backgroundColor: '#fff',
						}}
					>
						<div className="dropdown text-end">
							<a
								className="link-dark text-decoration-none dropdown-toggle"
								id="dropdownUser1"
								data-bs-toggle="dropdown"
								aria-expanded="false"
							>
								<p style={{ fontSize: '15px' }}>{headerDropDown}</p>
							</a>
							<ul
								className="dropdown-menu font-14"
								aria-labelledby="dropdownUser1"
								style={{ minWidth: '200px', zIndex: '10000' }}
							>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={
											() => handleFilterData('All')
											// FilterDatalist('orderBy=product_code&sortBy=asc', '', 'Active Customers')
										}
									>
										All
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={
											() => handleFilterData('Active Taxes')
											// FilterDatalist('orderBy=product_code&sortBy=asc', '', 'Active Customers')
										}
									>
										Active Taxes
									</a>
								</li>
								<li>
									<a
										className="dropdown-item border-0"
										onClick={
											() => handleFilterData('Inactive Taxes')
											// FilterDatalist('filterBy=status&filterValue=1', 'active', 'Duplicate Customers')
										}
									>
										Inactive Taxes
									</a>
								</li>
							</ul>
						</div>
					</div>
					<div className="">
						<table className="currency-table">
							<thead>
								<tr>
									{['TAX NAME', 'RATE (%)', ''].map((item, index) => (
										<th
											className="fs-5 fw-bold text-dark cursor-pointer"
											style={{ border: '1px solid #E5E6E8' }}
											onClick={() => {
												if (item === 'TAX NAME') {
													sortDataList({ order_by: 'tax_name' });
												} else if (item === 'RATE (%)') {
													sortDataList({ order_by: 'rate_in_percentage' });
												}
											}}
										>
											<div className="d-flex align-items-center gap-4">
												{item}
												{item === 'TAX NAME' && sortIconMap[sortDirection.tax_name]}
												{item === 'RATE (%)' && sortIconMap[sortDirection.rate_in_percentage]}
											</div>
										</th>
									))}
								</tr>
							</thead>
							<tbody>
								{taxRates.map((data, index) => (
									<tr key={index}>
										<td>
											<span className="d-flex align-items-center gap-4">
												<span>{data.tax_name}</span>
												{data.is_active && (
													<span
														className="px-3 py-1 fs-6 fw-light text-white rounded-4 text-center"
														style={{ backgroundColor: '#718096' }}
													>
														Active
													</span>
												)}
											</span>
										</td>
										<td
											style={{ borderLeft: '1px solid #E5E6E8' }}
										>{`${data.rate_in_percentage}%`}</td>
										<td className="text-end">
											<div
												style={{ position: 'relative', display: 'inline-block', padding: '2px' }}
											>
												<img
													src={
														isOpenTaxTableDropdown === data.tax_rate_id
															? upArrowIcon
															: downArrowIcon
													}
													alt="arrow"
													className="cursor-pointer"
													width={20}
													height={20}
													onClick={() => handleDropdown(data.tax_rate_id)}
												/>
											</div>
											{isOpenTaxTableDropdown === data.tax_rate_id && (
												<div className="tax-dropdown-container">
													<div
														className="d-flex align-items-center gap-4 p-2 cursor-pointer"
														onClick={() => handleOpenModal(index)}
													>
														<img
															src={editIcon}
															alt="arrow"
															className="cursor-pointer"
															width={20}
															height={20}
															onClick={() => handleOpenModal(index)}
														/>
														<div
															className="fs-5 font-semibold"
															style={{ color: '#555B67' }}
															onClick={() => handleOpenModal(index)}
														>
															Edit
														</div>
													</div>
													<div
														className="d-flex align-items-center gap-4 p-2 cursor-pointer"
														onClick={() => handleDeleteTaxRate(data.tax_rate_id)}
													>
														<img
															src={deleteIcon}
															alt="arrow"
															className="cursor-pointer"
															width={20}
															height={20}
															// onClick={() => {}}
														/>
														<div
															className="fs-5 font-semibold"
															style={{ color: '#555B67' }}
															// onClick={() => {}}
														>
															Delete
														</div>
													</div>
													<div className="d-flex align-items-center gap-4 p-2 cursor-pointer">
														<img
															src={marksIcon}
															alt="arrow"
															className="cursor-pointer"
															width={20}
															height={20}
															onClick={() => {}}
														/>
														<div
															className="fs-5 font-semibold"
															style={{ color: '#555B67' }}
															onClick={() => updateStatus(data.tax_rate_id, !data.is_active)}
														>
															{data.is_active ? 'Marks As Inactive' : 'Marks As Active'}
														</div>
													</div>
												</div>
											)}
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
					<div className="fs-2 fw-bold text-dark text-center mt-5">
						Simplify your billing with accurate tax rates!
					</div>
					<div
						className="fs-4 fw-light text-center mt-2"
						style={{ color: '#718096' }}
					>
						Add and manage tax rates easily for accurate invoices.
					</div>
					<div className="d-flex justify-content-center my-5">
						<Button
							type="button"
							className="btn-primary mt-0 px-4 py-3"
							button="Add New Tax Rates"
							onClick={() => handleOpenModal()}
							loader={false}
						/>
					</div>
					{/* <div className="d-flex justify-content-center">
				<Button
					type="button"
					className="btn-gray mt-0 px-4 py-3 fw-light"
					button="Import Tax Rates from File"
					icon={importFile}
					onClick={() => {}}
					loader={false}
				/>
			</div>
			<div
				className="fs-4 fw-semibold text-center mt-5"
				style={{ color: '#C3CBDC' }}
			>
				Keep your tax rates updated for accurate and automated billing.
			</div> */}
					{isOpenModal && (
						<Modal
							className="currency_model"
							title={taxRateForm.tax_rate_id !== null ? `Edit Tax Rate` : ' Add New Tax Rate'}
							isOpen={isOpenModal}
							onClose={() => {
								setIsOpenModal(false);
								resetTaxRate();
							}}
							cancelButton={() => {
								setIsOpenModal(false);
								resetTaxRate();
							}}
						>
							<div className="d-flex my-3 gap-2">
								<div className="col-6">
									<InputField
										label="Tax Name"
										placeholder="Tax name"
										autoFocus={true}
										type="text"
										required={true}
										value={taxRateForm.tax_name}
										onChange={(value) => handleFormData('tax_name', value, true)}
										error={error?.tax_name}
									/>
								</div>
								<div className="col-6">
									<InputField
										label="Rate(%)"
										placeholder="Rate in percentage"
										type="text"
										required={true}
										value={taxRateForm.rate_in_percentage}
										onChange={(valueData) => {
											var value = valueData?.replace(/[^0-9.]/g, '');
											handleFormData('rate_in_percentage', value, true);
										}}
										error={error?.rate_in_percentage}
									/>
								</div>
							</div>
							<div className="d-flex gap-3 align-items-center my-2">
								<div className="fs-5 fw-semibold text-dark">Active</div>
								<div className="form-check">
									<input
										class="form-check-input"
										type="checkbox"
										checked={taxRateForm.is_active}
										id="flexCheckDefault"
										onChange={(e) => handleFormData('is_active', !taxRateForm.is_active)}
									/>
								</div>
							</div>
							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'end',
									marginTop: '10px',
									gap: '10px',
								}}
							>
								<Button
									type="button"
									button={taxRateForm.tax_rate_id !== null ? `Update` : `Save`}
									className="mt-0 px-4 btn-primary relative"
									loader={loader}
									onClick={() => handleTaxRatesSave(taxRateForm.tax_rate_id !== null)}
								/>
								<Button
									type="button"
									button={`Cancel`}
									className="mt-0 px-4 btn-gray relative"
									onClick={() => {
										setIsOpenModal(false);
										resetTaxRate();
									}}
								/>
							</div>
						</Modal>
					)}
				</div>
			)}
		</div>
	);
}
